export const count2str = count => {
  if (count < 10000) {
    return count;
  } else if (count < 100000000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
};
